"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var web3_provider_1 = __importDefault(require("@walletconnect/web3-provider"));
var LinkedProviderStrategy = /*#__PURE__*/function () {
  function LinkedProviderStrategy() {
    (0, _classCallCheck2["default"])(this, LinkedProviderStrategy);
  }
  (0, _createClass2["default"])(LinkedProviderStrategy, [{
    key: "getProvider",
    value: function getProvider(rpcs) {
      var rpcObject = {};
      rpcs.forEach(function (rpc) {
        var chainId = rpc.chainId,
          url = rpc.url;
        rpcObject[+chainId] = url;
      });
      var provider = new web3_provider_1["default"]({
        rpc: rpcObject
      });
      return provider;
    }
  }, {
    key: "requestConnection",
    value: function requestConnection(provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return provider.enable();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "requestDisconnection",
    value: function requestDisconnection(provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return provider.disconnect();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  }, {
    key: "requestChangeNetwork",
    value: function requestChangeNetwork(provider, chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.warn("Please change to network ".concat(chainId));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    }
  }, {
    key: "getPreviosSession",
    value: function getPreviosSession(provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (provider.connector.connected) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", null);
            case 2:
              _context4.next = 4;
              return provider.enable();
            case 4:
              return _context4.abrupt("return", provider);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
    }
  }]);
  return LinkedProviderStrategy;
}();
exports["default"] = LinkedProviderStrategy;